var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDotsVerticalBig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 14.167C10.75 14.5812 10.4142 14.917 10 14.917C9.58581 14.917 9.25 14.5812 9.25 14.167C9.25 13.7528 9.58581 13.417 10 13.417C10.4142 13.417 10.75 13.7528 10.75 14.167Z",
    fill: "#19191A",
    stroke: "#505152",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 10C10.75 10.4142 10.4142 10.75 10 10.75C9.58581 10.75 9.25 10.4142 9.25 10C9.25 9.58581 9.58581 9.25 10 9.25C10.4142 9.25 10.75 9.58581 10.75 10Z",
    fill: "#19191A",
    stroke: "#505152",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 5.83301C10.75 6.24722 10.4142 6.58301 10 6.58301C9.5858 6.58301 9.25 6.24722 9.25 5.83301C9.25 5.4188 9.5858 5.08301 10 5.08301C10.4142 5.08301 10.75 5.4188 10.75 5.83301Z",
    fill: "#19191A",
    stroke: "#505152",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsVerticalBig);
export default __webpack_public_path__ + "static/media/dots-vertical-big.e591577203101dc8ab9b39b4133c4043.svg";
export { ForwardRef as ReactComponent };